import { render, staticRenderFns } from "./cModalProcInvasivo.vue?vue&type=template&id=d0269ca2&scoped=true"
import script from "./cModalProcInvasivo.vue?vue&type=script&lang=js"
export * from "./cModalProcInvasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0269ca2",
  null
  
)

export default component.exports